import React from 'react'
import { Badge, Table } from 'reactstrap'
import CustomerOrderItemStatusBadge from 'domains/customer-order/atoms/item-status-badge'
import SelectTableFilter from 'components/atoms/select-table-filter'
import RowButton from 'components/atoms/row-button'
import PriceUtil from 'utils/price-util'
import { ITEM_STATUS, REFUNDABLE_ORDER_ITEM_STATUS } from 'domains/customer-order/constants'

const customerOrderItemTableColumns = ({ handleClickAddToRefund }) => {
  // Custom Filter
  // Used to modify the filter in specific columns
  // eslint-disable-next-line react/prop-types
  const ItemStatusFilter = ({ column }) => {
    const options = Object.keys(ITEM_STATUS).map((key) => (
      {
        label : ITEM_STATUS[key],
        value : ITEM_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // Custom Cell
  // Used to modify the cell in specific columns
  const ImageCell  = (row) => <img style={{ width: '8rem' }} src={ row.cell.value } alt={ row.row.original.name } />
  const NameCell   = (row) => (
    <>
      <div>{ row.row.original.name }</div>
      <div><Badge color='primary'>{ row.row.original.productable_type }</Badge></div>
    </>
  )
  const PriceCell  = (row) => (
    <Table>
      <tbody>
        <tr>
          <th scope='row'>Price</th>
          <td>{ PriceUtil.format(row.row.original.price) }</td>
        </tr>
        <tr>
          <th scope='row'>Discount</th>
          <td>{ PriceUtil.format(row.row.original.discount_amount) }</td>
        </tr>
        <tr>
          <th scope='row'>Tax</th>
          <td>{ PriceUtil.format(row.row.original.tax_amount) }</td>
        </tr>
        <tr>
          <th scope='row'>{ 'Commission Price Ref' }</th>
          <td>{ PriceUtil.format(row.row.original.commission_price_ref) }</td>
        </tr>
      </tbody>
    </Table>

  )
  const StatusCell = (row) => <CustomerOrderItemStatusBadge status={ row.cell.value } />
  // eslint-disable-next-line react/prop-types
  const RefundActionCell = ({ cell: { row } }) => {
    // eslint-disable-next-line react/prop-types
    const isOpsCanRefund = Object.values(REFUNDABLE_ORDER_ITEM_STATUS['ops_before_shipping']).find((element) => element === row.original.status.toLowerCase())
    // eslint-disable-next-line react/prop-types
    const isCsCanRefund = Object.values(REFUNDABLE_ORDER_ITEM_STATUS['cs']).find((element) => element === row.original.status.toLowerCase())
    // eslint-disable-next-line react/prop-types
    const rowData = row.original
    // eslint-disable-next-line react/prop-types
    return isOpsCanRefund || isCsCanRefund ?
      <RowButton
        data={ rowData }
        color='danger'
        outline={ false }
        onClick={ handleClickAddToRefund }
        text="Add to Refund"
        // eslint-disable-next-line react/prop-types
        disabled={ !!rowData.refund }
      /> :
      <Badge
        pill
        className='badge-lg'
        color='primary'
      >
        Un-Refundable
      </Badge>
  }

  return (
    [
      {
        Header         : 'Image',
        accessor       : 'image',
        disableFilters : true,
        Cell           : ImageCell
      },
      {
        Header   : 'SKU',
        accessor : 'sku'
      },
      {
        Header   : 'Name',
        accessor : 'name',
        Cell     : NameCell
      },
      {
        Header   : 'Status',
        accessor : 'status',
        Filter   : ItemStatusFilter,
        Cell     : StatusCell
      },
      {
        Header         : 'Qty',
        accessor       : 'quantity',
        disableFilters : true
      },

      {
        Header         : 'Price',
        accessor       : 'price',
        disableFilters : true,
        Cell           : PriceCell
      },
      {
        Header         : 'Action',
        id             : 'refund_action',
        disableFilters : true,
        Cell           : RefundActionCell
      }
    ]
  )
}

export default customerOrderItemTableColumns
